<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'manage',
    subject: 'License',
  },
})

const page = {
  groupTitle: 'Administrasi',
  icon: 'ri-shield-star-line',
  color: 'error',
  title: 'Aktivasi & Reset Lisensi',
  description: 'Mengaktifkan lisensi instalasi dan mengganti edisi QUALIVA.',
  purpose: 'Panduan mengaktifkan lisensi QUALIVA dan memahami perbedaan edisi (Standard vs Assistant).',
  concept: [
    {
      icon: 'ri-key-2-line',
      title: 'Satu Lisensi per Instalasi',
      text: 'Lisensi ini mengaktifkan seluruh instalasi QUALIVA di fasilitas Anda, bukan per user. Setelah aktif, seluruh staf yang punya akun bisa langsung memakai fitur sesuai edisinya.',
    },
    {
      icon: 'ri-toggle-line',
      title: 'Edisi Menentukan Fitur AI',
      text: 'Edisi "Standard" tidak menyertakan AI Assistant; edisi "Assistant" menyertakannya. Mengaktifkan ulang dengan edisi berbeda otomatis menyalakan/mematikan menu AI Assistant untuk seluruh staf.',
    },
  ],
  steps: [
    { title: 'Buka menu Lisensi', detail: 'Biasanya sudah otomatis terisi saat instalasi awal — halaman ini untuk memverifikasi atau mengganti.' },
    { title: 'Masukkan License Key format XXXX-XXXX-XXXX-XXXX', detail: 'Pilih Edisi (Standard/Assistant).' },
    { title: 'Klik "Aktivasi"', detail: 'Status lisensi berubah menjadi Aktif, dan fitur sesuai edisi langsung tersedia.' },
    { title: '(Kalau perlu) Klik "Reset Lokal"', detail: 'Mencabut aktivasi saat ini supaya bisa diaktivasi ulang dengan key/edisi berbeda.' },
  ],
  tips: [
    'Simpan License Key Anda di tempat aman — Anda mungkin membutuhkannya lagi kalau harus instalasi ulang.',
  ],
  faq: [
    { q: 'Apa yang terjadi kalau lisensi tidak aktif?', a: 'Sebagian besar fitur operasional (Dokumen, Checklist, dst.) akan diblokir sampai lisensi diaktifkan — halaman aktivasi ini sendiri tetap bisa diakses tanpa lisensi aktif.' },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
